import Log from '@utils/log';
import BalloonEditor from './custom-balloon-editor';
import FileUpload from './file-upload.js';
import EmbeddedUploadAjax from '@ajax/embedded_upload';
import { getFeedItems } from './mention-customization';

import jQuery from 'jquery';

export default {
  setup: async function (dispatch, node, extraData = {}) {
    let jQnode = jQuery(node);

    let data = {
      toolbar: ['link', '|', 'mediaUpload'],
      mention: {
        feeds: [
          {
            dispatch: dispatch,
            marker: '@',
            feed: getFeedItems,
            minimumCharacters: 0,
          },
        ],
      },
      link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://',
        decorators: {
          detectDownloadable: {
            mode: 'automatic',
            callback: (url) => {
              url && url.startsWith(import.meta.env['VITE_API_URL']);
            },
            attributes: {
              download: true,
            },
          },
        },
      },
      ...extraData,
    };

    let editor = await BalloonEditor.create(node, data);

    if (typeof BalloonEditor === 'undefined') {
      Log.info('Failed to load ckeditor.', true);
      return;
    }

    jQuery(editor.plugins.get('LinkUI').formView.urlInputView.element)
      .find('input')
      .prop('placeholder', 'Type or paste website');

    editor.commands.get('enter').forceDisabled('enter-disable');
    editor.keystrokes.set('enter', (keyEvtData, cancel) => {
      if (!keyEvtData.shiftKey) {
        cancel();
        jQnode.blur();
        dispatch('enter');
      }
    });
    let docFileTypes = ['.xlsx', '.xls', '.doc', '.docx', '.ppt', '.pptx', '.txt', '.pdf', '.csv'];

    FileUpload.attach(
      editor.plugins.get('MediaUI').button.element,
      function (data) {
        // Need to ensure we have the proper selected text
        // even if the user has clicked around in the Uppy modal
        editor.model.change((writer) => {
          writer.setSelection(editor.plugins.get('MediaUI').highlightedRange);
        });
        const uploadResponse = data[0];

        EmbeddedUploadAjax.create(
          uploadResponse.uploadURL,
          uploadResponse.name,
          uploadResponse.type,
          uploadResponse.size,
          {
            withErrorHandling: false,
          }
        ).then((serverResponse) => {
          editor.execute(
            'link',
            `${import.meta.env['VITE_API_URL']}/api/embedded_uploads/${serverResponse.token}?name=${
              serverResponse.name
            }`
          );
          editor.model.change((writer) => {
            writer.setSelection(null);
          });

          dispatch('file-upload-complete', { text: editor.getData() });
        });
      },
      (percentage, file, progress) => {
        dispatch('upload-progress', {
          percentage: percentage,
          file: file,
          progress: progress,
        });
      },
      {
        maxNumberOfFiles: 1,
        maxSize: 15728640,
        uploadTypes: docFileTypes.concat(['audio/*', 'video/*', 'image/*']),
      }
    );

    let editingView = editor.editing.view;

    editingView.document.on(
      'clipboardInput',
      (evt, data) => {
        if (editor.isReadOnly) {
          return;
        }
        const dataTransfer = data.dataTransfer;
        let content = dataTransfer.getData('text/plain');
        data.content = editor.data.htmlProcessor.toView(content);
        editingView.scrollToTheSelection();
      },
      { priority: 'high' }
    );

    return editor;
  },

  setupMobile: async function (dispatch, node, extraData = {}) {
    let jQnode = jQuery(node);

    let data = {
      mention: {
        feeds: [
          {
            marker: '@',
            feed: getFeedItems,
            minimumCharacters: 0,
          },
        ],
      },
      ...extraData,
    };

    let editor = await BalloonEditor.create(node, data);

    if (typeof BalloonEditor === 'undefined') {
      Log.info('Failed to load ckeditor.', true);
      return;
    }

    editor.commands.get('enter').forceDisabled('enter-disable');
    editor.keystrokes.set('enter', (keyEvtData, cancel) => {
      if (!keyEvtData.shiftKey) {
        cancel();
        jQnode.blur();
        dispatch('enter');
      }
    });

    return editor;
  },
};
